import { render, staticRenderFns } from "./ProductCouponWindow.vue?vue&type=template&id=49c00afa&scoped=true"
import script from "./ProductCouponWindow.vue?vue&type=script&lang=js"
export * from "./ProductCouponWindow.vue?vue&type=script&lang=js"
import style0 from "./ProductCouponWindow.vue?vue&type=style&index=0&id=49c00afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c00afa",
  null
  
)

export default component.exports